export default "__VITE_ASSET__CZU0aJF9__"